export default __webpack_public_path__ + "static/1214-0789f0c350c869627f0d21fede130f1e.gif";